import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

export const routes = [{
    path: '/',
    name: 'index',
    component: function () {
      return import('../views/index/index.vue')
    },
  },
  {
    path: '/index',
    name: 'index',
    component: function () {
      return import('../views/index/index.vue')
    },
  },
  {
    path: '/videoIng',
    name: 'videoIng',
    component: function () {
      return import('../views/videoIng/index.vue')
    },
  },
  {
    path: '/videoIng_mp4',
    name: 'videoIng_mp4',
    component: function () {
      return import('../views/videoIng_mp4/index.vue')
    },
  },
  {
    path: '/cloubBooth',
    name: 'cloubBooth',
    component: function () {
      return import('../views/cloubBooth/index.vue')
    },
  },
  {
    path: '/article',
    name: 'article',
    component: function () {
      return import('../views/article/index.vue')
    },
  },
  {
    path: '/dateList',
    name: 'dateList',
    component: function () {
      return import('../views/2023ONLINE/dateList.vue')
    },
  }, {
    path: '/doctorList',
    name: 'doctorList',
    component: function () {
      return import('../views/2023ONLINE/doctorList.vue')
    },
  }, {
    path: '/doctorItem',
    name: 'doctorItem',
    component: function () {
      return import('../views/doctorItem/index.vue')
    },
  }, {
    path: '/2024CACAGO/collection',
    name: '20241206MN',
    component: function () {
      return import('../views/20241206MN/index.vue')
    },
  }, {
    path: '/2025collection',
    name: '2025collection',
    component: function () {
      return import('../views/20251212MN/index.vue')
    },
  }, {
    path: '/login',
    name: 'login',
    component: function () {
      return import('../views/2023ONLINE/login.vue')
    },
  }, {
    path: '/test_web',
    name: 'test_web',
    component: function () {
      return import('../views/test_web/index.vue')
    },
  },
]

// 防止连续点击多次路由报错
let routerPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(err => err);
};

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,
});

export default router;